import { SectionViewModel } from 'src/app/shared/models/sectionview.model';
import { SurveyViewModel } from 'src/app/shared/models/surveyview.model';
import { WorkflowView } from './workflowView.model';

export class SurveyResponse {
    surveyId: string;
    surveyName: string;
    userResponses: SurveyUserResponse[];
    isCommentsEditable:boolean=false;
    surveyDetail: SurveyViewModel;
    surveyWorkflow: WorkflowView;
}

export class SurveyUserResponse {
    userId: string;
    groupId:string;
    firstName: string;
    lastName: string;
    surveyUserResponseRel:string;
    get fullName () {
        return this.firstName + " " + this.lastName;
    }
    isAssigned:boolean=false;
    isSurveyCompleted: boolean;
    submissionDate: Date;
    responses: SurveyQuestionUserResponse[]
    section :SectionReponse[];

    incidentId:number;
    surveyInstanceId:string;
    agencyId : number;
    agencyName :string;

}

export class SurveyQuestionUserResponse {
    questionId: number;
    questionGuid:string;
    questionText: string;
    questionType: string;
    responseText: string;
    comments:string;
    responses: [];
    sequenceNumber:number;;
    isQuestionAnswered: boolean;
    surveyResponseRelId : number;
    lookUpQuestionId:number;
}

export class SectionReponse
{
     section:SectionViewModel;

    isSecParentQuestionVisible:boolean;
}
